import { useEffect, useMemo, useState } from "react";
import _ from "underscore";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { useEmployeFilter } from "../../../context/EmployeFilterContext";



export const useProjectPerformance = () => {
    const [date, setDate] = useState(new Date());
    const { selectedEmployee } = useEmployeFilter();
    const [options, setOptions] = useState({
        credits: {
            enabled: false
        },
        chart: {
            type: 'column',
        },
        title: {
            text: '',
        },
        legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'top',
            itemMarginTop: 10,
            itemMarginBottom: 10,
            symbolHeight: 12,
            symbolWidth: 30,
            symbolRadius: 0,

        },
        xAxis: {
            categories: [],
            crosshair: true,
            accessibility: {
                description: 'Hours',
            },
        },
        yAxis: {
            labels: {
                style: {
                    color: '#333',
                    fontSize: '10px',
                    fontWeight: 'normal'
                }
            },
            min: 10,
            title: {
                text: '',
            },
            tickInterval: 10,
        },
        tooltip: {
            valueSuffix: '',
        },
        plotOptions: {
            column: {
                pointPadding: 0.02,
                borderWidth: 0,
            },
            series: {
                pointWidth: 40
            }

        },
        series: []
    })
    const [loader, setLoader] = useState(false)





    useEffect(() => {
        if (!_.isEmpty(selectedEmployee)) {
            getMyAttendanceSummary()
        }
    }, [selectedEmployee])

    const getMyAttendanceSummary = async () => {
        setLoader(true)
        const payload = {
            month: new Date(date).getMonth() + 1,
            year: new Date(date).getFullYear(),
            requested_user_code: selectedEmployee?.user_code
        };

        try {
            const res = await services.getInvokeRemote('POST', Urls('GETPROJECTPERFORMANCEOVERVIEWSUMMARY'), payload);
            let rawData = res?.body?.data?.projectperformance_oveview_summary || [];
            rawData = rawData.filter((item) => item.project_name !== null);
            const targetHours = _.pluck(rawData, 'target_hours');
            const actualHours = _.pluck(rawData, 'actual_hours');
            const projectNames = _.pluck(rawData, 'project_name');

            setOptions(prevState => ({
                ...prevState,
                xAxis: {
                    ...prevState.xAxis,
                    categories: projectNames
                },
                yAxis: {
                    ...prevState.yAxis,
                    min: 10,
                    startOnTick: false,
                    endOnTick: true,
                    tickInterval: 10,

                },
                colors: [
                    '#505de6',
                    '#91bd53',
                ],
                series: [
                    {
                        name: 'Targeted',
                        data: targetHours
                    },
                    {
                        name: 'Actual',
                        data: actualHours
                    }
                ]
            }));

            setLoader(false)
        } catch (error) {
            console.error(error, "error");
            setLoader(false)

        }
    };




    return useMemo(() => ({
        options, loader
    }), [options, loader])
}